(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('suggestions', {
            parent: 'app',
            url: '/suggestions',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/suggestions/suggestions.html',
                    controller: 'SuggestionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('suggestions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
